import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";

import { useMode } from "@/shared/api";
import { ROUTES } from "@/shared/config";
import type { AppMode } from "@/shared/config";
import { Segmented, type SegmentedOption, type SegmentedVariant } from "@/shared/ui";

/**
 * Переключатель «Реальный счёт / Демо» (доработки §3).
 *
 * `solid`, а не `outline`: это не фильтр просмотра, а смена продукта, в
 * котором человек находится, — тот же вес, что у периода заработка на главной.
 * На самой главной вариант задаётся снаружи: там залитый период уже есть, и
 * второй такой же ряд табов читался бы как две одинаково громкие настройки
 * одного экрана.
 *
 * Переключение всегда уводит в корень раздела. Оставаться на месте нельзя:
 * половина адресов в демо ведёт на другие экраны, а половина недоступна вовсе,
 * и человек, переключившийся на экране вывода, оказался бы на заглушке без
 * объяснения, почему.
 */
export function ModeSwitch({
  className,
  variant = "solid",
}: {
  className?: string;
  variant?: SegmentedVariant;
}) {
  const { t } = useTranslation();
  const { mode, setMode } = useMode();
  const navigate = useNavigate();

  const options: readonly SegmentedOption<AppMode>[] = [
    { value: "real", label: t("demo.mode.real") },
    { value: "demo", label: t("demo.mode.demo") },
  ];

  return (
    <Segmented
      options={options}
      value={mode}
      onChange={(next) => {
        if (next === mode) return;
        setMode(next);
        void navigate(ROUTES.home);
      }}
      ariaLabel={t("demo.mode.label")}
      variant={variant}
      {...(className === undefined ? {} : { className })}
    />
  );
}
